import {FileText, X} from 'lucide-react';
import {AssetUploadButton, MAX_PDF_BYTES} from './AssetUploadButton';

// Filename for display: strip the {timestamp}-{random}- prefix our upload keys add, and
// drop any query string, so an uploaded "…/1699-ab12…-plan.pdf" reads as "plan.pdf".
function displayName(url: string): string {
  const last = decodeURIComponent(url.split('?')[0].split('/').pop() || 'file.pdf');
  return last.replace(/^\d{10,}-[0-9a-f]{8,}-/i, '');
}

// PDF field: a file chip (name + view + remove) once set, with Upload/Replace. Upload-only —
// no hand-typed URLs, so every asset lives in our bucket and can't rot.
export function PdfUploadField({
  groupSlug,
  isNew,
  value,
  onChange,
}: {
  groupSlug: string;
  isNew: boolean;
  value: string | undefined;
  onChange: (url: string | undefined) => void;
}) {
  return (
    <div className='space-y-2'>
      {value && (
        <div className='flex items-center gap-2 rounded-lg border bg-muted/30 px-3 py-2'>
          <FileText className='h-4 w-4 shrink-0 text-muted-foreground' />
          <span className='min-w-0 flex-1 truncate text-sm'>{displayName(value)}</span>
          <a
            href={value}
            target='_blank'
            rel='noreferrer'
            className='text-xs font-medium text-primary hover:underline'
          >
            View
          </a>
          <button
            type='button'
            onClick={() => onChange(undefined)}
            className='text-muted-foreground transition-colors hover:text-destructive'
            title='Remove'
          >
            <X className='h-4 w-4' />
          </button>
        </div>
      )}
      <div className='flex items-center gap-3'>
        <AssetUploadButton
          groupSlug={groupSlug}
          kind='pdf'
          accept='application/pdf'
          maxBytes={MAX_PDF_BYTES}
          disabled={isNew}
          label={value ? 'Replace' : 'Upload PDF'}
          onUploaded={onChange}
        />
        {isNew && <span className='text-xs text-muted-foreground'>Save the site first to upload.</span>}
      </div>
    </div>
  );
}
